const tabs = $('.def-tabs__title_active');

const showBlockTabs = function(name, index) {
    $(`.def-tabs-blocks[data-tabs-name=${name}]`).children().removeClass('def-tabs__block_active');
    $(`.def-tabs-blocks[data-tabs-name=${name}]`).children().eq(index).addClass('def-tabs__block_active');
}

if (tabs.length > 0) {
    // init tabs
    tabs.each(function (i, tab) {
        const name = $(tab).closest('[data-tabs-name]').attr('data-tabs-name');
        const index = $(tab).index();
        // меняем классы в блоках таба
        showBlockTabs(name, index);
    });

    $(document).on('click', '.def-tabs__title', function () {
        const tab = $(this);
        const name = tab.closest('[data-tabs-name]').attr('data-tabs-name');
        const index = tab.index();
        // меняем классы в хедере таба
        $('.def-tabs__title').removeClass('def-tabs__title_active');
        tab.addClass('def-tabs__title_active');
        // меняем классы в блоках таба
        showBlockTabs(name, index);
    });
}
